import { useFormikContext } from 'formik'
import React, { useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import useIndexDBValue from '../../../../../hook/useIndexDBValue'
import LabelRequired from '../../../../component/LabelRequired'
import TextField from '../../../../component/TextField'
import ModalICD10 from '../../../../phan-he-kham-benh/components/modal-icd10/ModalICD10'
import { IDanhSachDanhMuc } from '../../../../phan-he-tiep-nhan-thanh-toan/models/TiepDonModel'
import { KEY_DS_DANH_MUC_TIEP_DON } from '../../../../utils/Constant'

type Props = {}

const ChanDoanPTTT = (props: Props) => {
    const { values, setFieldValue } = useFormikContext<any>();
    const [icd10Field, setICD10Field] = useState<string>('');
    const [selectionModeICD10, setSelectionModeICD10] = useState<'checkbox' | 'radio'>();
    const [shouldOpenModalICD10, setShouldOpenModalICD10] = useState<boolean>(false);
    const { value: categories } = useIndexDBValue<IDanhSachDanhMuc>({
        key: KEY_DS_DANH_MUC_TIEP_DON,
    });

    const handleChangeSelect = (data: any) => {
        switch (icd10Field) {
            case 'surgeryInitialDiagnosis':
                setFieldValue('formData.surgeryInitialDiagnosis', data);
                break;
            case 'surgeryComorbidity':
                setFieldValue('formData.surgeryComorbidity', data);
                break;
            case 'surgeryPreoperativeDiagnosis':
                setFieldValue('formData.surgeryPreoperativeDiagnosis', data);
                break;
            case 'surgeryPostoperativeDiagnosis':
                setFieldValue('formData.surgeryPostoperativeDiagnosis', data);
                break;
            default:
                break;
        }
    };

    return (
        <Row className="mt-2">
            <Col xs="6" className="mb-2 grid-2_9-9_4">
                <LabelRequired label="Chẩn đoán ban đầu" className="spaces W-140" />
                <Row className="">
                    <Col xs="3" className="pe-0 position-relative">
                        <TextField
                            name="surgeryInitialDiagnosis"
                            value={values?.formData?.surgeryInitialDiagnosis?.code || ''}
                            disabled={values?.isViewModal}
                        />
                        <div className="spaces width-4">
                            <h6
                                className="position-absolute muc-huong cursor-pointer"
                                onClick={() => {
                                    if (values?.isViewModal) return;
                                    setICD10Field('surgeryInitialDiagnosis');
                                    setSelectionModeICD10('radio');
                                    setShouldOpenModalICD10(true);
                                }}
                            >
                                <i className="bi bi-three-dots fs-4 text-pri d-block spaces mt-5"></i>
                            </h6>
                        </div>
                    </Col>
                    <Col xs="9" className="ps-0">
                        <TextField
                            name="surgeryInitialDiagnosis"
                            value={
                                categories?.listICD10.find(
                                    (item: any) =>
                                        item.code === values?.formData?.surgeryInitialDiagnosis?.code
                                )?.name || ''
                            }
                            disabled={values?.isViewModal}
                        />
                    </Col>
                </Row>
            </Col>
            <Col xs="6" className="mb-2 grid-2_9-9_4">
                <LabelRequired label="Bệnh kèm theo" className="spaces W-140" />
                <Row className="">
                    <Col xs="3" className="pe-0 position-relative">
                        <TextField
                            name="surgeryComorbidity"
                            value={values?.formData?.surgeryComorbidity?.code || ''}
                            disabled={values?.isViewModal}
                        />
                        <div className="spaces width-4">
                            <h6
                                className="position-absolute muc-huong cursor-pointer"
                                onClick={() => {
                                    if (values?.isViewModal) return;
                                    setICD10Field('surgeryComorbidity');
                                    setSelectionModeICD10('radio');
                                    setShouldOpenModalICD10(true);
                                }}
                            >
                                <i className="bi bi-three-dots fs-4 text-pri d-block spaces mt-5"></i>
                            </h6>
                        </div>
                    </Col>
                    <Col xs="9" className="ps-0">
                        <TextField
                            name="surgeryComorbidity"
                            value={
                                categories?.listICD10.find(
                                    (item: any) =>
                                        item.code === values?.formData?.surgeryComorbidity?.code
                                )?.name || ''
                            }
                            disabled={values?.isViewModal}
                        />
                    </Col>
                </Row>
            </Col>
            <Col xs="6" className="grid-2_9-9_4">
                <LabelRequired label="Chẩn đoán trước PT" className="spaces W-140" />
                <Row className="">
                    <Col xs="3" className="pe-0 position-relative">
                        <TextField
                            name="surgeryPreoperativeDiagnosis"
                            value={values?.formData?.surgeryPreoperativeDiagnosis?.code || ''}
                            disabled={values?.isViewModal}
                        />
                        <div className="spaces width-4">
                            <h6
                                className="position-absolute muc-huong cursor-pointer"
                                onClick={() => {
                                    if (values?.isViewModal) return;
                                    setICD10Field('surgeryPreoperativeDiagnosis');
                                    setSelectionModeICD10('radio');
                                    setShouldOpenModalICD10(true);
                                }}
                            >
                                <i className="bi bi-three-dots fs-4 text-pri d-block spaces mt-5"></i>
                            </h6>
                        </div>
                    </Col>
                    <Col xs="9" className="ps-0">
                        <TextField
                            name="surgeryPreoperativeDiagnosis"
                            value={
                                categories?.listICD10.find(
                                    (item: any) =>
                                        item.code ===
                                        values?.formData?.surgeryPreoperativeDiagnosis?.code
                                )?.name || ''
                            }
                            disabled={values?.isViewModal}
                        />
                    </Col>
                </Row>
            </Col>
            <Col xs="6" className="grid-2_9-9_4">
                <LabelRequired label="Chẩn đoán sau PT" className="spaces W-140" />
                <Row className="">
                    <Col xs="3" className="pe-0 position-relative">
                        <TextField
                            name="surgeryPostoperativeDiagnosis"
                            value={values?.formData?.surgeryPostoperativeDiagnosis?.code || ''}
                            disabled={values?.isViewModal}
                        />
                        <div className="spaces width-4">
                            <h6
                                className="position-absolute muc-huong cursor-pointer"
                                onClick={() => {
                                    if (values?.isViewModal) return;
                                    setICD10Field('surgeryPostoperativeDiagnosis');
                                    setSelectionModeICD10('radio');
                                    setShouldOpenModalICD10(true);
                                }}
                            >
                                <i className="bi bi-three-dots fs-4 text-pri d-block spaces mt-5"></i>
                            </h6>
                        </div>
                    </Col>
                    <Col xs="9" className="ps-0">
                        <TextField
                            name="surgeryPostoperativeDiagnosis"
                            value={
                                categories?.listICD10.find(
                                    (item: any) =>
                                        item.code ===
                                        values?.formData?.surgeryPostoperativeDiagnosis?.code
                                )?.name || ''
                            }
                            disabled={values?.isViewModal}
                        />
                    </Col>
                </Row>
            </Col>
            {shouldOpenModalICD10 && (
                <ModalICD10
                    data={categories?.listICD10 || []}
                    handleClose={() => setShouldOpenModalICD10(false)}
                    setMauSelected={handleChangeSelect}
                    selectionMode={selectionModeICD10}
                />
            )}
        </Row>
    )
}

export default ChanDoanPTTT